import {i18n} from '@online-offer/i18n';
import {addMonths, isValid} from 'date-fns';
import {Text} from 'platform/foundation';
import {useDateTimeFormatter} from 'platform/locale';

import {isNil} from 'ramda';

import {Nullish, parseDate} from 'shared/web';

// A Car-Pass document is valid for 6 months from its issue date.
const CAR_PASS_VALIDITY_MONTHS = 6;
const DATE_SEPARATOR = ' · ';

interface CarPassValidityProps {
  downloadedAt: string | Nullish;
}

// Renders "Issued on: {date} · valid until: {date}" (valid until = issue date + 6 months).
// Shared by the web widget (mobile + desktop) and the print/PDF layout.
export function CarPassValidity(props: CarPassValidityProps) {
  const formatDateTime = useDateTimeFormatter();
  const issuedDate = parseDate(props.downloadedAt);

  // parseDate returns an Invalid Date for malformed non-empty strings (not null), which
  // isNil misses and would make date-fns format() throw. isValid guards both cases.
  if (isNil(issuedDate) || !isValid(issuedDate)) {
    return null;
  }

  const issuedOn = formatDateTime('dateShort', issuedDate);
  const validUntil = formatDateTime('dateShort', addMonths(issuedDate, CAR_PASS_VALIDITY_MONTHS));

  return (
    <Text size="small" color="secondary">
      {i18n.t('carPass.issuedOn', {date: issuedOn})}
      {DATE_SEPARATOR}
      {i18n.t('carPass.validUntil', {date: validUntil})}
    </Text>
  );
}
